import React from 'react';
import { Link } from 'react-router';

import styles from './styles.module.css';

interface LinkProps {
  to: string;
  label: string;
  disabled?: boolean;
  id?: string;
  customClass?: string;
}

const LinkButton: React.FC<LinkProps> = ({
  to = '',
  label = '',
  id = '',
  customClass = ''
}) => {
  return (
    <Link id={id} className={`${styles.link} ${customClass}`} to={to}>
      {label}
    </Link>
  );
};

export default LinkButton;
